<template>
  <div>
    <router-link
      :to="{
        name: 'industrial_admin_order_details',
        query: {
          branchName: data.branchName,
          branchId: data.branchId,
          companyID: this.$route.query.companyID,
          startDate: this.$route.query.startDate,
          endDate: this.$route.query.endDate,
        },
      }"
    >
      <button>{{ $t("text.clickButtons.viewDetails") }}</button>
    </router-link>
  </div>
</template>

<script>
import configObject from "../../../config";
import Jquery from "jquery";
let $ = Jquery;
export default {
  data() {
    return {
      data: {},
    };
  },
};
</script>

<style scoped>
button {
  background-color: #370f70;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
}
</style>
